module.exports = __webpack_public_path__ + "static/media/COMPANY_LOGO.35f6bc8b.png";